import React from "react";
import "./Powering.css";
import holoCat from "../../Media/holo-cat.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const Powering = () => {
  useEffect(() => {
    AOS.init({ duration: 2000, once: true });
  }, []);
  return (
    <div className="powering-section">
      <div className="powering-section-content">
        <div className="powering-section-text">
          <div className="powering-section-heading" data-aos="fade-up">
            <h1 className="powering-what-next">Powering What's Next</h1>
          </div>
          <div className="powering-section-description" data-aos="fade-up">
            <p className="powering-description-text">
              We are your partner built for ambition, driven by innovation, and
              trusted across industries to turn ideas into impact.
            </p>
          </div>
        </div>
        <div className="powering-section-image">
          <img className="holo-cat" src={holoCat} alt="Holo Cat" />
        </div>
      </div>
    </div>
  );
};

export default Powering;
